import React, { Component } from 'react';
import SocialComponent from '../components/hello/socialMedia/social.component';
import DescriptionComponent from '../components/hello/description.component';

class HelloContainer extends Component {
  render() {
    return (
      <section id="section-hello">
        <div className="container">
          <div className="jumbotron">
            <h1 className="animated bounceInDown">Hello, My Name is Amin Taghikhani.</h1>            
            <DescriptionComponent primaryTitle="Software Engineer" secondaryTitle="Back-End Developer"/>
            <div id="img-placeholder">
              <img src="images/Amin.jpg" width="160px" height="160px" />
            </div>
            <SocialComponent />
          </div>
        </div>
      </section>
    );
  }
}

export default HelloContainer;



// WEBPACK FOOTER //
// ./src/containers/hello.container.jsx